<script>
  import { onMount } from "svelte";
  import Conexoes from "../Classes/Conexoes";
  import Loading from "../componentes_basicos/Loading.svelte";

  let conexoes = new Conexoes();
  let carregando = true;
  let dadosMetas = [];
  
  let periodoStr = "";
  let diasPassados = 0;
  let diasRestantes = 0;

  const formatCurrency = (val) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(val);

  async function carregarDados() {
    carregando = true;
    let res = await conexoes.conecta("gastos_ciclo.php", {});
    
    if (res && res.success) {
      const gastosDB = res.gastos || {};
      const metasDB = res.metas || { Restaurante: 950, Comida: 1800, Suplementos: 200 };
      
      const dataInicio = new Date(res.data_inicio.split(' ')[0] + 'T00:00:00');
      const dataFim = new Date(res.data_fim.split(' ')[0] + 'T23:59:59');
      const hoje = new Date();
      
      periodoStr = `${dataInicio.toLocaleDateString('pt-BR')} até ${dataFim.toLocaleDateString('pt-BR')}`;

      const diasTotais = Math.round((dataFim - dataInicio) / (1000 * 60 * 60 * 24)) + 1;
      diasPassados = Math.round((hoje - dataInicio) / (1000 * 60 * 60 * 24)) + 1;
      
      if (diasPassados < 1) diasPassados = 1; 
      if (diasPassados > diasTotais) diasPassados = diasTotais;
      
      diasRestantes = diasTotais - diasPassados;
      if (diasRestantes < 1) diasRestantes = 1; 

      // Pegando os gastos de cada grupo
      let gastoRestaurante = gastosDB["Restaurante"] || 0;
      let gastoSuplementos = gastosDB["Suplementos"] || 0;
      let gastoComida = (gastosDB["Feira"] || 0) + 
                        (gastosDB["Padaria"] || 0) + 
                        (gastosDB["Lanche_lele_escola"] || 0) + 
                        (gastosDB["Lanche_lele_campestre"] || 0) + 
                        (gastosDB["Lanche_lele_outros"] || 0);

      // Adicionando a linha de suplementos
      dadosMetas = [
        calcularLinha("Restaurante", gastoRestaurante, metasDB["Restaurante"]),
        calcularLinha("Comida (Feira + Padaria + Lanches Lelê)", gastoComida, metasDB["Comida"]),
        calcularLinha("Suplementos", gastoSuplementos, metasDB["Suplementos"])
      ];
    }
    carregando = false;
  }

  function calcularLinha(categoria, gastoAtual, metaTotal) {
    let falta = metaTotal - gastoAtual;
    let mediaDiariaAtual = gastoAtual / diasPassados;
    let metaDiariaRestante = falta > 0 ? (falta / diasRestantes) : 0;

    return {
      categoria,
      metaTotal,
      gastoAtual,
      falta,
      mediaDiariaAtual,
      metaDiariaRestante
    };
  }

  onMount(() => {
    carregarDados();
  });
</script>
<style>
  .container {
    max-width: 1000px;
    margin: 20px auto;
    background: #f9f9f9;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  }

  .cabecalho-info {
    margin-bottom: 20px;
    padding: 15px;
    background: #eef1ff;
    border-left: 5px solid #3659fc;
    border-radius: 5px;
    color: #444;
    font-size: 14px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 15px;
    background: #fff;
  }

  th, td {
    border: 1px solid #ddd;
    padding: 12px;
    text-align: right;
  }

  th:first-child, td:first-child {
    text-align: left;
    font-weight: bold;
    color: #444;
  }

  th {
    background-color: #3659fc;
    color: white;
    text-align: center;
  }

  tr:hover {
    background-color: #f1f4ff;
  }

  .negativo {
    color: #d93025;
    font-weight: bold;
  }

  .positivo {
    color: #188038;
    font-weight: bold;
  }

  .destaque {
    background-color: #fbfbfc;
  }
</style>

<div class="container">
  <h2 style="color: #3659fc; margin-top: 0;">Controle de Metas de Alimentação (Dinâmico)</h2>
  
  {#if carregando}
    <div style="display:flex; justify-content:center; padding: 30px;">
      <Loading {carregando} />
    </div>
  {:else}
    <div class="cabecalho-info">
      <strong>Ciclo Atual:</strong> {periodoStr} <br/>
      <strong>Progresso do Período:</strong> {diasPassados} dias decorridos | {diasRestantes} dias restantes para fechar o mês
    </div>

    <div style="overflow-x: auto;">
      <table>
        <thead>
          <tr>
            <th>Categoria</th>
            <th>Meta Cadastrada (BD)</th>
            <th>Gasto Atual</th>
            <th>Falta para a Meta</th>
            <th>Média Diária Atual</th>
            <th>Meta Diária P/ Manter</th>
          </tr>
        </thead>
        <tbody>
          {#each dadosMetas as linha}
            <tr>
              <td>{linha.categoria}</td>
              <td class="destaque" style="font-weight: 500;">{formatCurrency(linha.metaTotal)}</td>
              <td>{formatCurrency(linha.gastoAtual)}</td>
              <td class={linha.falta < 0 ? 'negativo' : 'positivo'}>
                {formatCurrency(linha.falta)}
              </td>
              <td>{formatCurrency(linha.mediaDiariaAtual)}</td>
              <td class="destaque" style="font-weight: bold; color: #3659fc;">
                {formatCurrency(linha.metaDiariaRestante)}
              </td>
            </tr>
          {/each}
        </tbody>
      </table>
    </div>
  {/if}
</div>